<template>
  <div class="usage-stats-content">
    <p class="title"><i class="material-icons">&#xE001;</i></p>
    <p class="subtitle">{{ $t('errors.unable_to_load_data') }}</p>
    <div class="status" @click="onRetry()">
      <p>{{ $t('ui.buttons.retry') }}</p>
      <i class="material-icons">&#xE5D5;</i>
    </div>
    <simple-line-chart :data="getData()" :is-disabled="true" class="is-light" />
  </div>
</template>

<script>
import SimpleLineChart from 'views/charts/SimpleLineChart';

export default {
  name: 'UsageStatsContent',
  props: {
    contentType: {
      type: String,
      required: true,
    },
  },
  components: {
    SimpleLineChart,
  },
  methods: {
    onRetry() {
      this.$parent.setIndividualData(this.contentType);
    },
    getData() {
      const date = new Date();

      return [
        {
          time: date,
          value: 0,
        },
        {
          time: date - 1,
          value: 0,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.title {
  color: $warning;
  cursor: default;

  i {
    line-height: calc(20 / 24);
  }
}

.status {
  color: $grey-darker;
  cursor: pointer;

  i {
    opacity: 0.64;
  }
}
</style>
